// @ts-nocheck
import React from 'react';
import { ApplyPluginsType, dynamic } from '/home/jenkins/workspace/ansible-ui/route-forecast-ui/node_modules/@umijs/runtime';
import * as umiExports from './umiExports';
import { plugin } from './plugin';
import LoadingComponent from '@/components/PageLoading/index';

export function getRoutes() {
  const routes = [
  {
    "path": "/login",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__UserLayout' */'@/layouts/UserLayout'), loading: LoadingComponent}),
    "exact": true
  },
  {
    "path": "/",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__BasicLayout' */'@/layouts/BasicLayout'), loading: LoadingComponent}),
    "routes": [
      {
        "path": "/",
        "redirect": "/welcome",
        "exact": true
      },
      {
        "path": "/welcome",
        "name": "首页",
        "icon": "home",
        "hideInMenu": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Welcomes' */'/home/jenkins/workspace/ansible-ui/route-forecast-ui/src/pages/Welcomes'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "path": "/exportTaskInfo",
        "name": "导出任务",
        "icon": "home",
        "hideInMenu": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__DownloadTask' */'/home/jenkins/workspace/ansible-ui/route-forecast-ui/src/pages/DownloadTask'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "name": "实时广播",
        "path": "/realTimeBroadcast",
        "icon": "home",
        "pinYin": "ssgb",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__RealTimeBroadcast' */'/home/jenkins/workspace/ansible-ui/route-forecast-ui/src/pages/RealTimeBroadcast'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "name": "全链路实时监控大屏",
        "path": "/welcome1",
        "icon": "home",
        "pinYin": "ssqgwdkdsd",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__SiteRealTimeBiling' */'/home/jenkins/workspace/ansible-ui/route-forecast-ui/src/pages/SiteRealTimeBiling'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "path": "/transportSchedule",
        "name": "运输计划",
        "icon": "home",
        "routes": [
          {
            "name": "班次计划发布",
            "path": "/transportSchedule/schedulePublish",
            "icon": "home",
            "pinYin": "bcjhfb",
            "domain": "tdcs",
            "exact": true
          }
        ]
      },
      {
        "path": "/dispatch",
        "name": "中控中心",
        "icon": "home",
        "routes": [
          {
            "name": "审批/查询权限配置",
            "path": "/dispatch/auditConfig",
            "icon": "home",
            "pinYin": "spcxqxpz",
            "domain": "tdcs",
            "exact": true
          },
          {
            "name": "运输任务管理",
            "path": "/dispatch/taskManage",
            "icon": "home",
            "pinYin": "ysrwgl",
            "domain": "tdcs",
            "exact": true
          },
          {
            "name": "运输调整审批",
            "path": "/dispatch/taskAudit",
            "icon": "home",
            "pinYin": "ystzsp",
            "domain": "tdcs",
            "exact": true
          },
          {
            "name": "运输调整查询",
            "path": "/dispatch/taskApply",
            "icon": "home",
            "pinYin": "ystzsq",
            "domain": "tdcs",
            "exact": true
          },
          {
            "name": "正/加班车审批",
            "path": "/dispatch/extraAudit",
            "icon": "home",
            "pinYin": "zjbcsp",
            "domain": "tdcs",
            "exact": true
          },
          {
            "name": "正/加班车申请",
            "path": "/dispatch/extraApply",
            "icon": "home",
            "pinYin": "zjbcsq",
            "domain": "tdcs",
            "exact": true
          },
          {
            "name": "事件上报查询",
            "path": "/dispatch/baseData/operate/carWarning/prescriptionFine",
            "icon": "home",
            "pinYin": "sjsbcx",
            "domain": "tdcs",
            "exact": true
          },
          {
            "name": "满载/装载标准申请",
            "path": "/dispatch/fullLoadDeparture",
            "icon": "home",
            "pinYin": "mzfc",
            "domain": "tdcs",
            "exact": true
          },
          {
            "name": "满载/装载标准审批",
            "path": "/dispatch/FullDepartureApproval",
            "icon": "home",
            "pinYin": "mzfcsp",
            "domain": "tdcs",
            "exact": true
          },
          {
            "name": "临时路由申请",
            "path": "/dispatch/temporaryRouteRequest",
            "icon": "home",
            "pinYin": "lslysq",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TemporaryRouteRequest' */'/home/jenkins/workspace/ansible-ui/route-forecast-ui/src/pages/TemporaryRouteRequest'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "临时路由审批",
            "path": "/dispatch/temporaryRouteAdjustmentApproval",
            "icon": "home",
            "pinYin": "lslytzsp",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__AdjustmentApproval' */'/home/jenkins/workspace/ansible-ui/route-forecast-ui/src/pages/AdjustmentApproval'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "大流向空爆",
            "path": "/dispatch/largeFlowAirBurst",
            "icon": "home",
            "pinYin": "dlxkb",
            "domain": "tdcs",
            "exact": true
          }
        ]
      },
      {
        "path": "/basicDatas",
        "name": "基础数据",
        "icon": "home",
        "pinYin": "jcsj",
        "routes": [
          {
            "name": "干线标准时效",
            "path": "/basicDatas/routeLineRatioTime",
            "icon": "home",
            "pinYin": "gxbzsx",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__RouteLineRatioTime' */'/home/jenkins/workspace/ansible-ui/route-forecast-ui/src/pages/RouteLineRatioTime'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "网点打卡时间维护",
            "path": "/clock/maintenance",
            "icon": "home",
            "pinYin": "wdjjjsj",
            "domain": "tdcs",
            "exact": true
          },
          {
            "name": "区县管理",
            "path": "/basic/edifact/district",
            "icon": "home",
            "pinYin": "qxgl",
            "domain": "tdcs",
            "exact": true
          },
          {
            "name": "时效标准",
            "path": "/basicDatas/countyDistance",
            "icon": "home",
            "pinYin": "qxsxjl",
            "domain": "routetime",
            "exact": true
          },
          {
            "name": "国家管理",
            "path": "/basic/edifact/system/countryManagement",
            "icon": "home",
            "pinYin": "qxgl",
            "domain": "tdcs",
            "exact": true
          },
          {
            "name": "非直营加班车配置",
            "path": "/basicDatas/nonDirectOvertime",
            "icon": "home",
            "pinYin": "fzyjbc",
            "domain": "tdcs",
            "exact": true
          },
          {
            "name": "班次管理",
            "path": "/basicDatas/shiftManagement",
            "icon": "home",
            "pinYin": "bcgl",
            "domain": "tdcs",
            "exact": true
          },
          {
            "name": "网点管理",
            "path": "/basicDatas/siteManage",
            "icon": "home",
            "pinYin": "wdgl",
            "domain": "tdcs",
            "exact": true
          },
          {
            "name": "分拨管理",
            "path": "/basicDatas/centerManage",
            "icon": "home",
            "pinYin": "fbgl",
            "domain": "tdcs",
            "exact": true
          },
          {
            "name": "营运区管理",
            "path": "/basicDatas/centerCircle",
            "icon": "home",
            "pinYin": "fbqgl",
            "domain": "tdcs",
            "exact": true
          },
          {
            "name": "行政区县管理",
            "path": "/basicDatas/districtCountyManagement",
            "icon": "home",
            "pinYin": "xzqxgl",
            "domain": "tdcs",
            "exact": true
          },
          {
            "name": "站点间时效距离",
            "path": "/basicDatas/stationDistance",
            "icon": "home",
            "pinYin": "zdjsxjl",
            "domain": "tdcs",
            "exact": true
          },
          {
            "name": "车线成本定价维护",
            "path": "/basicDatas/realTimeCarLine",
            "icon": "home",
            "pinYin": "cxcbdjwh",
            "domain": "tdcs",
            "exact": true
          },
          {
            "name": "满载/装载标准维护",
            "path": "/basicDatas/otCarDispatchOrFull",
            "icon": "home",
            "pinYin": "jbcmzfcbzwh",
            "domain": "tdcs",
            "exact": true
          },
          {
            "name": "车线实际成本分摊规则",
            "path": "/basicDatas/costSharingMaintenance",
            "icon": "home",
            "pinYin": "cbfdfzwh",
            "domain": "tdcs",
            "exact": true
          },
          {
            "name": "供应商维护",
            "path": "/basicDatas/supplierMangment",
            "icon": "home",
            "pinYin": "cbfdfzwh",
            "domain": "tdcs",
            "exact": true
          },
          {
            "name": "区域属性管理",
            "path": "/basicDatas/areaPropertyManagement",
            "icon": "home",
            "pinYin": "qysxgl",
            "domain": "tdcs",
            "exact": true
          },
          {
            "name": "流向序号配置",
            "path": "/basicDatas/flowSequence",
            "icon": "home",
            "pinYin": "lxxhpz",
            "domain": "tdcs",
            "exact": true
          },
          {
            "name": "运输重系数",
            "path": "/basicDatas/shippingweightfactor",
            "icon": "home",
            "pinYin": "yszxs",
            "domain": "tdcs",
            "exact": true
          },
          {
            "name": "类区分类",
            "path": "/basicDatas/areaClassify",
            "icon": "home",
            "pinYin": "lqfl",
            "domain": "tdcs",
            "exact": true
          },
          {
            "name": "装载率系数维护",
            "path": "/basicDatas/loadFactor",
            "icon": "home",
            "pinYin": "zzlxswh",
            "domain": "tdcs",
            "exact": true
          },
          {
            "name": "运力采购单价(手工)",
            "path": "/basicDatas/purchasePrice",
            "icon": "home",
            "pinYin": "ylcgdj",
            "domain": "tdcs",
            "exact": true
          },
          {
            "name": "计划运力采购单价",
            "path": "/basicDatas/purchasePriceManual",
            "icon": "home",
            "pinYin": "ylcgdjsh",
            "domain": "tdcs",
            "exact": true
          },
          {
            "name": "路由调整限制",
            "path": "/basicDatas/routingLimits",
            "icon": "home",
            "pinYin": "lytzxz",
            "domain": "tdcs",
            "exact": true
          },
          {
            "name": "组织架构",
            "path": "/basicDatas/flowAirBurst",
            "icon": "home",
            "pinYin": "zzjg",
            "domain": "tdcs",
            "exact": true
          },
          {
            "name": "全程时效标准维护",
            "path": "/basic/sites/efficiencyStandardMaintenance",
            "icon": "home",
            "pinYin": "qcsxbzwh",
            "domain": "tdcs",
            "exact": true
          },
          {
            "name": "运输单价预算值维护",
            "path": "/basicDatas/transportPriceBudget",
            "icon": "home",
            "pinYin": "ysdjyszwh",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TransportPriceBudget' */'/home/jenkins/workspace/ansible-ui/route-forecast-ui/src/pages/TransportPriceBudget'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "类区分类(新)",
            "path": "/basicDatas/areaClassifyNew",
            "icon": "home",
            "pinYin": "yszxs",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__AreaClassifyNew' */'/home/jenkins/workspace/ansible-ui/route-forecast-ui/src/pages/AreaClassifyNew'), loading: LoadingComponent}),
            "exact": true
          }
        ]
      },
      {
        "path": "/siteDecision",
        "name": "现场决策",
        "icon": "home",
        "pinYin": "xcjc",
        "routes": [
          {
            "name": "干线预计出发货量",
            "path": "/siteDecision/centerweightviewnew",
            "icon": "home",
            "pinYin": "gxyjcfhl",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__CenterWeightViewTest' */'/home/jenkins/workspace/ansible-ui/route-forecast-ui/src/pages/CenterWeightViewTest'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "干线预计出发货量(SR)",
            "path": "/siteDecision/centerweightviewnew2",
            "icon": "home",
            "pinYin": "gxyjcfhl2",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Centerweightviewnew2' */'/home/jenkins/workspace/ansible-ui/route-forecast-ui/src/pages/Centerweightviewnew2'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "干线预计出发货量旧",
            "path": "/siteDecision/centerweightview",
            "icon": "home",
            "pinYin": "gxyjcfhl",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__CenterWeightViewTest2' */'/home/jenkins/workspace/ansible-ui/route-forecast-ui/src/pages/CenterWeightViewTest2'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "网点预计到达货量",
            "path": "/siteDecision/centerweightviewSite",
            "icon": "home",
            "pinYin": "wdyjcfhl",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__CenterWeightViewSite' */'/home/jenkins/workspace/ansible-ui/route-forecast-ui/src/pages/CenterWeightViewSite'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "分拨-网点货量/运力监控",
            "path": "/siteDecision/centerweightviewSiteNew",
            "icon": "home",
            "pinYin": "fbwdhlyljk",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__CenterWeightViewSiteNew' */'/home/jenkins/workspace/ansible-ui/route-forecast-ui/src/pages/CenterWeightViewSiteNew'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "运单时效轨迹",
            "path": "/siteDecision/centerRouteTrajectory",
            "icon": "home",
            "pinYin": "ydsxgj",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__CenterRouteTrajectory' */'/home/jenkins/workspace/ansible-ui/route-forecast-ui/src/pages/CenterRouteTrajectory'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "分拨路线轨迹视图",
            "path": "/siteDecision/centerRouteTrajectoryView",
            "icon": "home",
            "pinYin": "fblxgjnew",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__CenterRouteTrajectoryFlow' */'/home/jenkins/workspace/ansible-ui/route-forecast-ui/src/pages/CenterRouteTrajectoryFlow'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "车辆监控",
            "path": "/siteDecision/vehicleMonitoring",
            "icon": "home",
            "pinYin": "cljk",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__VehicleMonitoring' */'/home/jenkins/workspace/ansible-ui/route-forecast-ui/src/pages/VehicleMonitoring'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "车辆监控(SR)",
            "path": "/siteDecision/vehicleMonitoringNew",
            "icon": "home",
            "pinYin": "cljkx",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__VehicleMonitoringNew' */'/home/jenkins/workspace/ansible-ui/route-forecast-ui/src/pages/VehicleMonitoringNew'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "分时段进出货量",
            "path": "/siteDecision/inOutVolumeTimeSlot",
            "icon": "home",
            "pinYin": "fsdjcchl",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__InOutVolumeTimeSlot' */'/home/jenkins/workspace/ansible-ui/route-forecast-ui/src/pages/InOutVolumeTimeSlot'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "临时路由管理",
            "path": "/siteDecision/temparRouteManagen",
            "icon": "home",
            "pinYin": "lslygl",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TemparRouteManagen' */'/home/jenkins/workspace/ansible-ui/route-forecast-ui/src/pages/TemparRouteManagen'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "临时路由调整日志",
            "path": "/siteDecision/temporaryRouteJournal",
            "icon": "home",
            "pinYin": "lslytzrz",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TemporaryRouteJournal' */'/home/jenkins/workspace/ansible-ui/route-forecast-ui/src/pages/TemporaryRouteJournal'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "预计-路线＆运力匹配表",
            "path": "/siteDecision/provincePlan",
            "icon": "home",
            "pinYin": "yjlxylppb",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ProvincePlan' */'/home/jenkins/workspace/ansible-ui/route-forecast-ui/src/pages/ProvincePlan'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "网点-分拨货量/运力监控",
            "path": "/siteDecision/siteCenterCapacityMonitor",
            "icon": "home",
            "pinYin": "wdfbhlyljk",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__SiteCenterCapacityMonitor' */'/home/jenkins/workspace/ansible-ui/route-forecast-ui/src/pages/SiteCenterCapacityMonitor'), loading: LoadingComponent}),
            "exact": true
          }
        ]
      },
      {
        "path": "/efficiencyAnalysis",
        "name": "时效分析",
        "icon": "home",
        "pinYin": "sxfx",
        "routes": [
          {
            "name": "兑现率(全国)",
            "path": "/efficiencyAnalysis/waybillCashRateNationwide",
            "icon": "home",
            "pinYin": "dxl",
            "domain": "routetime",
            "exact": true
          },
          {
            "name": "干线中转率",
            "path": "/efficiencyAnalysis/locationFrequency",
            "icon": "home",
            "pinYin": "dxl",
            "domain": "routetime",
            "exact": true
          },
          {
            "name": "静态时效兑现率",
            "path": "/efficiencyAnalysis/staticEfficiencyCashRate",
            "icon": "home",
            "pinYin": "jtsxdxl",
            "domain": "routetime",
            "exact": true
          },
          {
            "name": "全程兑现率",
            "path": "/efficiencyAnalysis/staticEfficiencyCashRateNew",
            "icon": "home",
            "pinYin": "jtsxdxl",
            "domain": "routetime",
            "exact": true
          },
          {
            "name": "运单时长明细(旧)",
            "path": "/efficiencyAnalysis/waybillDuration",
            "icon": "home",
            "pinYin": "ydscmx",
            "domain": "routetime",
            "exact": true
          },
          {
            "name": "运单时长明细",
            "path": "/efficiencyAnalysis/waybillDurationNew",
            "icon": "home",
            "pinYin": "ydscmx",
            "domain": "routetime",
            "exact": true
          },
          {
            "name": "运单兑现明细(旧)",
            "path": "/efficiencyAnalysis/waybillCashRate",
            "icon": "home",
            "pinYin": "yddxmx",
            "domain": "routetime",
            "exact": true
          },
          {
            "name": "运单兑现明细",
            "path": "/efficiencyAnalysis/waybillCashRateNew",
            "icon": "home",
            "pinYin": "yddxmx",
            "domain": "routetime",
            "exact": true
          },
          {
            "name": "运单时长看板",
            "path": "/efficiencyAnalysis/waybillDurationBoard",
            "icon": "home",
            "pinYin": "ydsckb",
            "domain": "routetime",
            "exact": true
          },
          {
            "name": "运单时长",
            "path": "/efficiencyAnalysis/waybillDurationBoardNew",
            "icon": "home",
            "pinYin": "ydsckb",
            "domain": "routetime",
            "exact": true
          },
          {
            "name": "未按路由走货明细",
            "path": "/efficiencyAnalysis/notPressRouteTransportGoods",
            "icon": "home",
            "pinYin": "walyzhmx",
            "domain": "routetime",
            "exact": true
          },
          {
            "name": "未按路由走货看板",
            "path": "/efficiencyAnalysis/notPressRouteBoard",
            "icon": "home",
            "pinYin": "walyzhkb",
            "domain": "routetime",
            "exact": true
          },
          {
            "name": "未按路由走货看板(SR)",
            "path": "/efficiencyAnalysis/notPressRouteBoardNew",
            "icon": "home",
            "pinYin": "walyzhkbx",
            "domain": "routetime",
            "exact": true
          },
          {
            "name": "中转率明细",
            "path": "/efficiencyAnalysis/delayDetails",
            "icon": "home",
            "pinYin": "hjywmx",
            "domain": "routetime",
            "exact": true
          },
          {
            "name": "应签收未签",
            "pinYin": "yqswq",
            "icon": "home",
            "path": "/support/shouldSignUnsigned",
            "domain": "tdcs",
            "exact": true
          },
          {
            "name": "网点交件准点率",
            "pinYin": "wdjjzdl",
            "icon": "home",
            "path": "/manage/siteDeliveryRate",
            "domain": "tdcs",
            "exact": true
          },
          {
            "name": "未按路由走货明细(SR)",
            "path": "/efficiencyAnalysis/notDeliveredAccordingToTheRoute",
            "icon": "home",
            "pinYin": "walyzhmx",
            "domain": "routetime",
            "exact": true
          },
          {
            "name": "运单兑现明细(新)",
            "path": "/efficiencyAnalysis/waybillCashRateNew2",
            "icon": "home",
            "pinYin": "yddxmx",
            "domain": "routetime",
            "exact": true
          },
          {
            "name": "车辆押车监控",
            "path": "/efficiencyAnalysis/carBacklogMonitoring",
            "icon": "home",
            "pinYin": "clycjk",
            "domain": "routetime",
            "exact": true
          },
          {
            "name": "城市到城市时效管理",
            "path": "/efficiencyAnalysis/cityToCityTimelinessManagement",
            "icon": "home",
            "pinYin": "csdcssxgj",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__CityToCityTimelinessManagement' */'/home/jenkins/workspace/ansible-ui/route-forecast-ui/src/pages/CityToCityTimelinessManagement'), loading: LoadingComponent}),
            "exact": true
          }
        ]
      },
      {
        "path": "/retentionAnalysis",
        "name": "留仓分析",
        "icon": "home",
        "pinYin": "lcfx",
        "routes": [
          {
            "name": "每日网点离岗留仓",
            "path": "/retentionAnalysis/outletsdepartStorehouseNew",
            "icon": "home",
            "pinYin": "mrwdlglc",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__OutletsDepartStorehouseNew' */'/home/jenkins/workspace/ansible-ui/route-forecast-ui/src/pages/OutletsDepartStorehouseNew'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "每日网点离岗留仓(SR)",
            "path": "/retentionAnalysis/outletsdepartStorehouseSR",
            "icon": "home",
            "pinYin": "mrwdlglcsr",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__OutletsDepartStorehouseOpt' */'/home/jenkins/workspace/ansible-ui/route-forecast-ui/src/pages/OutletsDepartStorehouseOpt'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "每日网点离岗留仓(OPT)",
            "path": "/retentionAnalysis/outletsdepartStorehouseOpt",
            "icon": "home",
            "pinYin": "mrwdlglcopt",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__OutletsDepartStorehouseOpt' */'/home/jenkins/workspace/ansible-ui/route-forecast-ui/src/pages/OutletsDepartStorehouseOpt'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "分拨12点留仓排名",
            "path": "/retentionAnalysis/stayStoreTop",
            "icon": "home",
            "pinYin": "fblcpm",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__StayStoreTop' */'/home/jenkins/workspace/ansible-ui/route-forecast-ui/src/pages/StayStoreTop'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "留仓原因分析",
            "path": "/retentionAnalysis/stayStoreCause",
            "icon": "home",
            "pinYin": "lcyyfx",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__StayStoreCause' */'/home/jenkins/workspace/ansible-ui/route-forecast-ui/src/pages/StayStoreCause'), loading: LoadingComponent}),
            "exact": true
          }
        ]
      },
      {
        "path": "/structuralAnalysis",
        "name": "货量结构",
        "icon": "home",
        "pinYin": "lxhyjgfx",
        "routes": [
          {
            "name": "路由货量明细",
            "path": "/structuralAnalysis/odGoodsWeightInfo",
            "icon": "home",
            "pinYin": "lyhlmx",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ODgoodsWeightInfo' */'/home/jenkins/workspace/ansible-ui/route-forecast-ui/src/pages/ODgoodsWeightInfo'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "路由货量明细(SR)",
            "path": "/structuralAnalysis/odGoodsWeightInfoNew",
            "icon": "home",
            "pinYin": "lyhlmxx",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__odGoodsWeightInfoSR' */'/home/jenkins/workspace/ansible-ui/route-forecast-ui/src/pages/odGoodsWeightInfoSR'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "营运区流向货量",
            "path": "/structuralAnalysis/provincialFlowToWeight",
            "icon": "home",
            "pinYin": "yyqlxhl",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ProvincialFlowToWeight' */'/home/jenkins/workspace/ansible-ui/route-forecast-ui/src/pages/ProvincialFlowToWeight'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "营运区-营运区货量矩阵",
            "path": "/structuralAnalysis/provinceCargoVolumeMatrix",
            "icon": "home",
            "pinYin": "shlzz",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ProvinceCargoVolumeMatrix' */'/home/jenkins/workspace/ansible-ui/route-forecast-ui/src/pages/ProvinceCargoVolumeMatrix'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "营运区-营运区货量矩阵(SR)",
            "path": "/structuralAnalysis/provinceCargoVolumeMatrixSr",
            "icon": "home",
            "pinYin": "shlzz",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ProvinceCargoVolumeMatrixSr' */'/home/jenkins/workspace/ansible-ui/route-forecast-ui/src/pages/ProvinceCargoVolumeMatrixSr'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "始发-全国流向货量(SR)",
            "path": "/structuralAnalysis/operatingAreaFlowOfWeight",
            "icon": "home",
            "pinYin": "yyqlxhlsr",
            "domain": "tdcs",
            "exact": true
          },
          {
            "name": "运营部-运营部货量矩阵(SR)",
            "path": "/structuralAnalysis/operatingAreaCargoVolumeMatrixSr",
            "icon": "home",
            "pinYin": "yybyybhljzsr",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__OperatingAreaCargoVolumeMatrixSr' */'/home/jenkins/workspace/ansible-ui/route-forecast-ui/src/pages/OperatingAreaCargoVolumeMatrixSr'), loading: LoadingComponent}),
            "exact": true
          }
        ]
      },
      {
        "path": "/cost",
        "name": "运输效率",
        "icon": "home",
        "pinYin": "cb",
        "routes": [
          {
            "name": "流向装载率明细",
            "path": "/cost/directionLoadingRateDetail",
            "icon": "home",
            "pinYin": "lxzzlmx",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__DirectRateNew2' */'/home/jenkins/workspace/ansible-ui/route-forecast-ui/src/pages/DirectRateNew2'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "线路装载率明细",
            "path": "/cost/lineLoadingRateDetail",
            "icon": "home",
            "pinYin": "xlzzlmx",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__LineLoadingRateNew' */'/home/jenkins/workspace/ansible-ui/route-forecast-ui/src/pages/LineLoadingRateNew'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "干线装载率",
            "path": "/cost/lineLoadingRateDetailsr",
            "icon": "home",
            "pinYin": "xlzzlmxsr",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__LineLoadingRateSr' */'/home/jenkins/workspace/ansible-ui/route-forecast-ui/src/pages/LineLoadingRateSr'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "装载率激励",
            "path": "/cost/loadingRateIncentive",
            "icon": "home",
            "pinYin": "zzljl",
            "domain": "tdcs",
            "exact": true
          },
          {
            "name": "装载率明细(月报)",
            "path": "/cost/lineLoadingRateDetailNew",
            "icon": "home",
            "pinYin": "xlzzlmx",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__LineLoadingRateNew2' */'/home/jenkins/workspace/ansible-ui/route-forecast-ui/src/pages/LineLoadingRateNew2'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "装载率明细(月报)(SR)",
            "path": "/cost/lineLoadingRateDetailNewsr",
            "icon": "home",
            "pinYin": "xlzzlmxsr",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__LineLoadingRateNewSr' */'/home/jenkins/workspace/ansible-ui/route-forecast-ui/src/pages/LineLoadingRateNewSr'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "实际流向投产比明细表",
            "path": "/cost/actualProductionRatioDetail",
            "icon": "home",
            "pinYin": "sjlxtcbmxb",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ActualProductionRatioDetail2' */'/home/jenkins/workspace/ansible-ui/route-forecast-ui/src/pages/ActualProductionRatioDetail2'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "规划流向投产比明细表",
            "path": "/cost/planProductionRatioDetail",
            "icon": "home",
            "pinYin": "ghlxtcbmxb",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ActualProductionRatioDetail' */'/home/jenkins/workspace/ansible-ui/route-forecast-ui/src/pages/ActualProductionRatioDetail'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "实际流向投产比明细表(SR)",
            "path": "/cost/actualProductionRatioDetailsr",
            "icon": "home",
            "pinYin": "sjlxtcbmxbsr",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ActualProductionRatioDetailsr' */'/home/jenkins/workspace/ansible-ui/route-forecast-ui/src/pages/ActualProductionRatioDetailsr'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "规划流向投产比明细表(SR)",
            "path": "/cost/planProductionRatioDetailsr",
            "icon": "home",
            "pinYin": "ghlxtcbmxbsr",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__PlanProductionRatioDetailsr' */'/home/jenkins/workspace/ansible-ui/route-forecast-ui/src/pages/PlanProductionRatioDetailsr'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "实时车线成本",
            "path": "/cost/realCarTimeCost",
            "icon": "home",
            "pinYin": "sscxcb",
            "domain": "tdcs",
            "exact": true
          },
          {
            "name": "流向装载率明细",
            "path": "/cost/directionLoadingRateDetailNew",
            "icon": "home",
            "pinYin": "lxzzlmx",
            "domain": "tdcs",
            "exact": true
          },
          {
            "name": "分段装载率明细",
            "path": "/cost/roadLoadingRateDetail",
            "icon": "home",
            "pinYin": "ldzzlmx",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__RoadLoadingRate' */'/home/jenkins/workspace/ansible-ui/route-forecast-ui/src/pages/RoadLoadingRate'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "实时线路装载率明细",
            "path": "/cost/nowlineLoadingRate",
            "icon": "home",
            "pinYin": "xlzzlmx",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__NowLineLoadingRate' */'/home/jenkins/workspace/ansible-ui/route-forecast-ui/src/pages/NowLineLoadingRate'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "每日车线复盘表",
            "path": "/cost/vehicleLineReview",
            "pinYin": "cxfp",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__VehicleLineReview' */'/home/jenkins/workspace/ansible-ui/route-forecast-ui/src/pages/VehicleLineReview'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "中转频次",
            "path": "/cost/transferFrequencyNew",
            "icon": "home",
            "pinYin": "zzpc",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TransferFrequencyNew' */'/home/jenkins/workspace/ansible-ui/route-forecast-ui/src/pages/TransferFrequencyNew'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "网点线装载率",
            "path": "/cost/vehicleLoadingRate",
            "icon": "home",
            "pinYin": "wdfbclzzl",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__VehicleLoadingRate' */'/home/jenkins/workspace/ansible-ui/route-forecast-ui/src/pages/VehicleLoadingRate'), loading: LoadingComponent}),
            "exact": true
          }
        ]
      },
      {
        "path": "/costAnalysis",
        "name": "成本分析",
        "icon": "home",
        "pinYin": "cbfx",
        "routes": [
          {
            "name": "车线实际成本日报",
            "path": "/costAnalysis/carActualCostDetail",
            "icon": "home",
            "pinYin": "cxsjcbmxb",
            "domain": "tdcs",
            "exact": true
          },
          {
            "name": "运输成本",
            "path": "/costAnalysis/transportCost",
            "icon": "home",
            "pinYin": "yscb",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TransportCost' */'/home/jenkins/workspace/ansible-ui/route-forecast-ui/src/pages/TransportCost'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "车线成本视图",
            "path": "/costAnalysis/realCarTimeCost",
            "icon": "home",
            "pinYin": "cxcbst",
            "domain": "tdcs",
            "exact": true
          },
          {
            "name": "车线规划成本测算",
            "path": "/costAnalysis/carPlanCalculate",
            "icon": "home",
            "pinYin": "sscxcb",
            "domain": "tdcs",
            "exact": true
          }
        ]
      },
      {
        "path": "/planTool",
        "name": "规划工具",
        "icon": "home",
        "pinYin": "ghgj",
        "routes": [
          {
            "name": "路由车线检测工具",
            "path": "/planTool/routeLineDetection",
            "icon": "home",
            "pinYin": "lycxjc",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__RouteLineDetection' */'/home/jenkins/workspace/ansible-ui/route-forecast-ui/src/pages/RouteLineDetection'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "联通情况分析",
            "path": "/planTool/connectivityAnalysis",
            "icon": "home",
            "pinYin": "ltqkfx",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ConnectivityAnalysis' */'/home/jenkins/workspace/ansible-ui/route-forecast-ui/src/pages/ConnectivityAnalysis'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "工具包",
            "path": "/planTool/routeEncrypt",
            "icon": "home",
            "pinYin": "gjb",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__RouteEncrypt' */'/home/jenkins/workspace/ansible-ui/route-forecast-ui/src/pages/RouteEncrypt'), loading: LoadingComponent}),
            "exact": true
          }
        ]
      },
      {
        "path": "/developingPage",
        "name": "系统工具",
        "icon": "home",
        "pinYin": "xtgj",
        "routes": [
          {
            "name": "运输任务数据重推",
            "path": "/developingPage/transportationTaskDataRePush",
            "icon": "home",
            "pinYin": "rsrwsjtsjl",
            "domain": "tdcs",
            "exact": true
          },
          {
            "name": "未按路由走货看板2",
            "path": "/developingPage/notPressRouteTransportGoodsBoard",
            "icon": "home",
            "pinYin": "walyzhkb",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__NotPressRouteTransportGoodsBoard' */'/home/jenkins/workspace/ansible-ui/route-forecast-ui/src/pages/NotPressRouteTransportGoodsBoard'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "交接单管理",
            "path": "/developingPage/handoverOrderManagement",
            "icon": "home",
            "pinYin": "jjdgl",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__HandoverOrderManagement' */'/home/jenkins/workspace/ansible-ui/route-forecast-ui/src/pages/HandoverOrderManagement'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "分拨预计出发货量",
            "path": "/developingPage/centerweightviewNew",
            "icon": "home",
            "pinYin": "fbyjcfhlNew",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__CenterWeightViewNew' */'/home/jenkins/workspace/ansible-ui/route-forecast-ui/src/pages/CenterWeightViewNew'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "货量与运力匹配明细表",
            "path": "/developingPage/volumeCapacityMatching",
            "icon": "home",
            "pinYin": "sqlxylppb",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__VolumeCapacityMatching' */'/home/jenkins/workspace/ansible-ui/route-forecast-ui/src/pages/VolumeCapacityMatching'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "预货量数据统计",
            "path": "/developingPage/estimatedVolumeView",
            "icon": "home",
            "pinYin": "mrwdlclc",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__EstimatedVolumeView' */'/home/jenkins/workspace/ansible-ui/route-forecast-ui/src/pages/EstimatedVolumeView'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "分拨路线信息汇总",
            "path": "/developingPage/centerMassageMap",
            "icon": "home",
            "pinYin": "fblxxzh",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__centerMassageMap' */'/home/jenkins/workspace/ansible-ui/route-forecast-ui/src/pages/centerMassageMap'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "分拨信息明细",
            "path": "/developingPage/centerInfo",
            "icon": "home",
            "pinYin": "fblxxzh",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__CenterInfo' */'/home/jenkins/workspace/ansible-ui/route-forecast-ui/src/pages/CenterInfo'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "分拨信息聚合",
            "path": "/developingPage/centerInfoAggre",
            "icon": "home",
            "pinYin": "fblxxzh",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__CenterInfoAggre' */'/home/jenkins/workspace/ansible-ui/route-forecast-ui/src/pages/CenterInfoAggre'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "基础信息查询汇总",
            "path": "/developingPage/searchBasicInfo",
            "icon": "home",
            "pinYin": "fblxxzh",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__SearchBasicInfo' */'/home/jenkins/workspace/ansible-ui/route-forecast-ui/src/pages/SearchBasicInfo'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "分拨路线轨迹",
            "path": "/developingPage/centerRouteTrajectoryNew",
            "icon": "home",
            "pinYin": "fblxgj2",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__CenterRouteTrajectoryNew' */'/home/jenkins/workspace/ansible-ui/route-forecast-ui/src/pages/CenterRouteTrajectoryNew'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "分拨到达看板",
            "path": "/developingPage/centerArrivalBoard",
            "icon": "home",
            "pinYin": "fbddkb",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__CenterArrivalBoard' */'/home/jenkins/workspace/ansible-ui/route-forecast-ui/src/pages/CenterArrivalBoard'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "分拨预测到达看板",
            "path": "/developingPage/centerForecastArrival",
            "icon": "home",
            "pinYin": "fbycddkb",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__CenterForecastArrival' */'/home/jenkins/workspace/ansible-ui/route-forecast-ui/src/pages/CenterForecastArrival'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "分拨出发看板",
            "path": "/developingPage/centerDepartBoard",
            "icon": "home",
            "pinYin": "fbddkb",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__CenterDepartBoard' */'/home/jenkins/workspace/ansible-ui/route-forecast-ui/src/pages/CenterDepartBoard'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "分拨预测出发看板",
            "path": "/developingPage/forecastCenterDepartBoard",
            "icon": "home",
            "pinYin": "fbyccfkb",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ForecastCenterDepartBoard' */'/home/jenkins/workspace/ansible-ui/route-forecast-ui/src/pages/ForecastCenterDepartBoard'), loading: LoadingComponent}),
            "exact": true
          }
        ]
      },
      {
        "path": "/testPage",
        "name": "测试页面",
        "icon": "home",
        "pinYin": "sxfx",
        "routes": [
          {
            "name": "天象库存",
            "path": "/testPage/maxStock",
            "icon": "home",
            "pinYin": "txkc",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__MaxStock' */'/home/jenkins/workspace/ansible-ui/route-forecast-ui/src/pages/MaxStock'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "分拨货量视图",
            "path": "/testPage/centerWeightViewTest",
            "icon": "home",
            "pinYin": "sqlxylppbcs",
            "exact": true
          },
          {
            "name": "预计路线运力",
            "path": "/testPage/provinceCapacity",
            "icon": "home",
            "pinYin": "sqlxylppbyjcs",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ProvincePlanTest' */'/home/jenkins/workspace/ansible-ui/route-forecast-ui/src/pages/ProvincePlanTest'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "测试",
            "path": "/testPage/test2",
            "icon": "home",
            "pinYin": "test",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Test2' */'/home/jenkins/workspace/ansible-ui/route-forecast-ui/src/pages/Test2'), loading: LoadingComponent}),
            "exact": true
          }
        ]
      },
      {
        "name": "文件下载",
        "path": "/fileExport",
        "icon": "home",
        "pinYin": "wjxz",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__FileExport' */'/home/jenkins/workspace/ansible-ui/route-forecast-ui/src/pages/FileExport'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "name": "通用文件下载",
        "path": "/fileDownload",
        "icon": "home",
        "pinYin": "wjxz",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__FileDownload' */'/home/jenkins/workspace/ansible-ui/route-forecast-ui/src/pages/FileDownload'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "path": "/systemSetting",
        "name": "系统设置",
        "icon": "setting",
        "pinYin": "xtsz",
        "routes": [
          {
            "name": "配置项",
            "path": "/systemSetting/configurationItem",
            "icon": "home",
            "pinYin": "pzx",
            "domain": "tdcs",
            "exact": true
          },
          {
            "name": "导入模板",
            "path": "/systemSetting/dataImport",
            "icon": "home",
            "pinYin": "drmb",
            "domain": "tdcs",
            "exact": true
          },
          {
            "name": "功能提醒设置",
            "path": "/systemSetting/featureReminder",
            "icon": "home",
            "pinYin": "gntxsz",
            "domain": "tdcs",
            "exact": true
          }
        ]
      },
      {
        "path": "/paramsSetting",
        "name": "参数设置",
        "icon": "setting",
        "pinYin": "cssz",
        "routes": [
          {
            "name": "业务参数",
            "path": "/paramsSetting/smartRouteParamConfig",
            "icon": "home",
            "pinYin": "znlycspz",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__SmartRouteParamConfig' */'/home/jenkins/workspace/ansible-ui/route-forecast-ui/src/pages/SmartRouteParamConfig'), loading: LoadingComponent}),
            "exact": true
          }
        ]
      },
      {
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Exception__404' */'/home/jenkins/workspace/ansible-ui/route-forecast-ui/src/pages/Exception/404'), loading: LoadingComponent}),
        "exact": true
      }
    ]
  }
];

  // allow user to extend routes
  plugin.applyPlugins({
    key: 'patchRoutes',
    type: ApplyPluginsType.event,
    args: { routes },
  });

  return routes;
}
